import { render, staticRenderFns } from "./order-sku-chart.vue?vue&type=template&id=33922a36&scoped=true&"
import script from "./order-sku-chart.vue?vue&type=script&lang=js&"
export * from "./order-sku-chart.vue?vue&type=script&lang=js&"
import style0 from "./order-sku-chart.vue?vue&type=style&index=0&id=33922a36&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33922a36",
  null
  
)

export default component.exports